import { Button } from "antd"
import { useEffect, useState } from "react"
import ReactMarkdown from "react-markdown"
import { useDispatch, useSelector } from "react-redux"
import { setUpdateModalShow } from "../../../redux/update-modal/updateModalSlice"
import { UpdateInfo } from "../util/useUpdate"
import styles from "./UpdateModal.module.scss"
import { useTranslation } from "react-i18next"
import { selectIntl } from "../../../redux/intl/intlSlice"
import { globalConfig } from "../../../config/config"

interface UpdateModalProps {
    updateInfo: Omit<UpdateInfo, "beta">
}



export const UpdateModal = (props: UpdateModalProps) => {
    const [content, setContent] = useState("")
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { locale } = useSelector(selectIntl)

    useEffect(() => {
        const func = async () => {
            // 获取md文件
            const response = await fetch(props.updateInfo.changeLog[locale] || props.updateInfo.changeLog["en"])
            if (response.ok) {
                const changeLog = await response.text()
                setContent(changeLog)
            }
        }
        func().catch(e=>{console.log("获取更新日志失败!!")})
    }, [props.updateInfo.changeLog, locale])

    // 关闭
    const onClose = () => {
        dispatch(setUpdateModalShow(false))
        // 记录通知的版本, 不再反复提醒
        globalConfig.setItem("pushedVersion", props.updateInfo.version)
    }

    // 去更新
    const onUpdate = () => {
        // 纯React版本：使用window.open打开更新链接
        window.open(props.updateInfo.redirectUrl, '_blank');
    }

    return (
        <div className={styles.updateModal}>
            <div className={styles.header}>
                <div className={styles.title}>
                {`${t('new_version')} V${props.updateInfo.version}`}
                </div>
                <div className={styles.close} title={t('close')} onClick={onClose} >
                    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2580" width="16" height="16"><path d="M237.497 192.997L831.13 786.63l-45.354 45.353-593.631-593.631z" fill="#FFFFFF" p-id="2581"></path><path d="M831.92 237.58L236.732 832.767l-45.353-45.353 595.187-595.187z" fill="#ffffff" p-id="2582"></path></svg>
                </div>
            </div>
            <div className={styles.content}>
                <ReactMarkdown>{content}</ReactMarkdown>
            </div>
            <div className={styles.footer}>
                {/* <Button shape="round">忽略</Button> */}
                <Button type="primary" className={styles['custom-button']} onClick={onUpdate}>{String(t('update_now'))}</Button>
            </div>
        </div>
    )
}